module.exports = function ($scope) {

  $scope.images = makeArrayOfImages();
  $scope.selected = $scope.images[0];


  $scope.onClick = function($event, item){
    $event.preventDefault();
    $scope.selected = item;
  }
}


function makeArrayOfImages() {
  var arr = [];
  for (var i = 0; i < 3; i++) {
    arr.push({
      id: i+1,
      url: 'https://placehold.co/500/500?text=Image+' + i
    })
  }
  return arr;
}
